import { render, staticRenderFns } from "./LeftRelatorios.vue?vue&type=template&id=205ccbee"
import script from "./LeftRelatorios.vue?vue&type=script&lang=js"
export * from "./LeftRelatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports